import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyApps = loadable(() => import(/* webpackChunkName: "content/guest/widgets/apps" */ './Apps'), 'Apps');
